import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

/**
   * Created by Alon Yampolski on 06/08/2018.
   * This is a specific implementation to handle previous implementation of indicatorIconColumn
   * don't use this component for any other reason but backwards compatibility of indicatorIconColumn
   * For this implementation, the usage of "eval" should be ignored by sonar!
   */
@Component({
  selector: 'indicator-icon',
  templateUrl: './indicator-icon.component.html',
  styleUrls: ['./indicator-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IndicatorIconComponent implements OnInit {

  @Input()
  value;
  @Input()
  data: any;
  indicatorEvaluation;
  displayValue;

  ngOnInit() {
    const columnValue = this.value;
    this.indicatorEvaluation = eval(this.data.displayCondition);
    this.data.columnName =="Actionability" ? this.displayValue = this.value[this.data.columnName].substring(0,1) : this.displayValue = "!";
  }
}
